<template>
  <div class="two-container" >
    <div class="little-title">{{ $theme ?  '品牌荣誉' : 'BRAND HONOR'}}</div>
    <div class="model-four" :style="{transform: 'scale('+scal+')' }">
      <div
        @mouseenter="activeHonor = item.code"
        :class="{ 'active-list': activeHonor == item.code }"
        class="list-item"
        v-for="(item, ind) in honorList"
        :key="ind + 'sd'"
        :style="{left: activeHonor < item.code ? item.activeLeft : item.left}"
      >
        <div class="name">{{ $theme ? item.name : item.enName }}</div>
        <div class="right-img">
          <HonoraryCertificate v-if="item.code == 1"></HonoraryCertificate>
          <StandardLead v-if="item.code == 2"></StandardLead>
          <PatentCertificate v-if="item.code == 3"></PatentCertificate>
          <Cooperation v-if="item.code == 4"></Cooperation>
        </div>
        <!-- <img :src="item.img" alt="">
        <div class="desc" v-show="activeHonor == item.code">{{ item.desc }}</div> -->
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>

<script>
import Cooperation from "../cooperation/Index.vue";
import HonoraryCertificate from "../honorary-certificate/Index.vue";
import StandardLead from "../standard-lead/Index.vue";
import PatentCertificate from "../patent-certificate/Index.vue";
export default {
  data() {
    return {
      activeHonor: 1,
      honorList: [
        {
          name: "相关获奖",
          enName: 'Awards',
          code: 1,
          img: "",
          left: "0",
          activeLeft: "0",
        },
        {
          name: "标准引领",
          enName: 'Standards',
          code: 2,
          img: "",
          left: "100px",
          activeLeft: "1540px",
        },
        {
          name: "发明专利",
          enName: 'Patents',
          code: 3,
          img: "",
          left: "200px",
          activeLeft: "calc(1540px + 100px)",
        },
        {
          name: "产学研合作",
          enName: 'Cooperation',
          code: 4,
          img: "",
          left: "300px",
          activeLeft: "calc(1540px + 200px)",
        },
      ],
      scal: 1,
    };
  },
  props: {},
  components: {
    HonoraryCertificate,
    StandardLead,
    PatentCertificate,
    Cooperation,
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {
    var element = document.body.clientWidth;
    this.scal = element/1920
  },
  watch: {},
};
</script>

<style scoped lang="scss">
@import "./Index.scss";
</style>
